import { Directive, ElementRef } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[ngxShowPassword]'
})

export class ShowPasswordDirective {
  isShown: boolean;

  constructor(private el: ElementRef) {
    this.initSetup();
  }

  toggleIcon(icon: HTMLElement): void {
    this.isShown = !this.isShown;

    this.el.nativeElement.setAttribute('type', this.isShown ? 'text' : 'password');
    icon.className = this.isShown ? 'fa fa-eye ms-2 pointer' : 'fa fa-eye-slash ms-2 pointer';
  }

  initSetup(): void {
    const input = this.el.nativeElement.parentNode;
    const icon = document.createElement('i');
    icon.className = 'fa fa-eye-slash ms-2 pointer';

    icon.addEventListener('click', event => {
      this.toggleIcon(icon);
    });

    input.appendChild(icon);
  }
}
